import { AppState, HomePageMiamiAppState } from '../../../initialStateRegistration';
import {
  HomePageMiamiImageLinksSection,
  HomePageMiamiMinorSectionsWithoutMore,
  HomePageMiamiTopSection,
  SectionNames,
} from './homePageMiami.initialState';

export const getHomePage = (state: AppState) => (state as HomePageMiamiAppState).template;

export const getFeaturedArticle = (key: HomePageMiamiTopSection) => (state: AppState) => getHomePage(state)[key].featuredArticle;

export const getSectionArticlesByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key].articles;

export const getSectionImageLinks = (key: HomePageMiamiImageLinksSection) => (state: AppState) => getHomePage(state)[key].imageLinks;

export const getSectionTitleByKey = (key: HomePageMiamiMinorSectionsWithoutMore | HomePageMiamiImageLinksSection) => (state: AppState) => getHomePage(state)[key].sectionTitle;

export const getMoreButtonTextByKey = (key: HomePageMiamiTopSection) => (state: AppState) => getHomePage(state)[key].showMoreText;

export const getMoreButtonURLByKey = (key: HomePageMiamiTopSection) => (state: AppState) => getHomePage(state)[key].showMoreURL;

export const getTopSectionTitle = (key: HomePageMiamiTopSection) => (state: AppState) => getHomePage(state)[key].sectionTitle;

export const getBannerImage = (key: HomePageMiamiTopSection) => (state: AppState) => getHomePage(state)[key].image;

export const getBannerLink = (key: HomePageMiamiTopSection) => (state: AppState) => getHomePage(state)[key].link;

export const getMetadataDescription = (state: AppState) => getHomePage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getHomePage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getHomePage(state).metadataImage;

export const getHreflangData = (state: AppState) => getHomePage(state).hreflangData;
